(function (angular) {
    'use strict'; 
    angular.module('Common')      
        .factory('broadcastChannels', ['channelsProvider', function(channelsProvider){
            return {
                fbMessenger: {
                    label: channelsProvider.fbMessenger.name,
                    id: 'fbMessenger',
                    allowed: channelsProvider.fbMessenger.allowed
                },
                sms: {
                    label: channelsProvider.sms.name,
                    id: 'sms',
                    allowed: channelsProvider.sms.allowed
                },
                appMessaging: {
                    label: channelsProvider.appMessaging.name,
                    id: 'appMessaging',
                    allowed: channelsProvider.appMessaging.allowed
                },
                whatsApp: {
                    label: channelsProvider.whatsApp.name,
                    id: 'whatsApp',
                    allowed: channelsProvider.whatsApp.allowed
                }
            }
        }]);

})(window.angular);